import request from '@/libs/request'

// 用户 列表
export function userListApi (data) {
  return request({
    url: `user/user`,
    method: 'get',
    params: data
  })
}

// 用户 详情
export function userInfoApi (id) {
  return request({
    url: `user/user/` + id,
    method: 'get'
  })
}

// 用户 启用禁用
export function userStatusChangeApi (id) {
  return request({
    url: `user/statusChange/` + id,
    method: 'post',
  })
}

// 根据手机号查询用户
export function searchUserByPhoneApi (phone) {
  return request({
    url: `user/searchUserByPhone`,
    method: 'get',
    params: {
      phone: phone
    }
  })
}


